export const addLeadingZeroes = (id: string): string => {
  const prefix = '000000';
  const paddedId = prefix.slice(0, prefix.length - id.length) + id;
  return paddedId;
};
